// document.addEventListener('click', function (e) {

//     const button = e.target.closest('[data-mm-gift-add]');

//     if (!button) return;

//     e.preventDefault();

//     if (button.classList.contains('loading')) return;

//     button.classList.add('loading');

//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             id: button.dataset.variantId,
//             quantity: 1
//         })
//     })
//     .then(() => {
//         return fetch('/cart.js');
//     })
//     .then(response => response.json())
//     .then(() => {
//         alert('Before refresh');
//         try {
//             halo.updateSidebarCart(cart);
//             alert('After refresh');
//         } catch (e) {
//             console.error('updateSidebarCart failed:', e);
//             alert(e.message);
//         }
//     })
//     .catch(console.error)
//     .finally(() => {

//         button.classList.remove('loading');

//     });

// });
$(document).on('click', '[data-mm-gift-toggle]', function () {

    $(this)
        .next('[data-mm-gift-body]')
        .stop(true, true)
        .slideToggle(300);

    $(this)
        .parent()
        .toggleClass('is-open');

});